import React, { Component } from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import { injectIntl, intlShape } from 'react-intl';

import SpinnerLoginButton from '../components/buttons/SpinnerLoginButton';

import { login } from '../api/auth';

import { loginAction } from '../redux/actions/auth';
import { fetchTablets } from '../redux/actions/tablet';

import tabletBack from '../images/tablet-back.jpg';

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.state = {
      email: '',
      password: '',
      loading: false,
    };
  }

  async onSubmit() {
    const user = this.state;
    const { dispatch, history, intl } = this.props;

    this.setState({ loading: true });

    await login(user).then((result) => {
      if (result.data.error) {
        toastr.error(null, result.data.error);
        this.setState({ loading: false });
        return;
      }
      if (result.data.errorMessage) {
        const errorText = intl.formatMessage({ id: result.data.errorMessage });
        toastr.error(null, errorText);
        this.setState({ loading: false });
        return;
      }

      localStorage.setItem('user', JSON.stringify(result.data));
      dispatch(loginAction(result.data));
      dispatch(fetchTablets());
      history.push('/panel');
    }, (error) => {
      console.log('err', error);
      console.log('err', error.response);
      toastr.error(error);
    });
    this.setState({ loading: false });
  }

  handleChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  keyPress = (e) => {
    if (e.keyCode === 13) this.onSubmit();
  }

  render() {
    const { email, password, loading } = this.state;
    const { intl } = this.props;

    const loginText = intl.formatMessage({ id: 'login' });
    const emailText = intl.formatMessage({ id: 'userDetail.email' });
    const passwordText = intl.formatMessage({ id: 'userDetail.password' });

    return (
      <Wrapper>
        <FormWrapper>
          <LoginTitle>{loginText}</LoginTitle>
          <Input
            id="email"
            label={emailText}
            value={email}
            onChange={(e) => this.handleChange(e)}
            onKeyDown={(e) => this.keyPress(e)}
          />
          <Input
            id="password"
            label={passwordText}
            type="password"
            value={password}
            onChange={(e) => this.handleChange(e)}
            onKeyDown={(e) => this.keyPress(e)}
          />
          <LoginButton onClick={this.onSubmit} text={loginText} loading={loading} />
        </FormWrapper>
      </Wrapper>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
};

const Wrapper = styled.div`
background-image: url(${tabletBack});
width: 100vw;
height: 100vh;
background-repeat: no-repeat;
background-attachment: fixed;
background-position: center; 
background-size: contain;
display:flex;
justify-content: center;
align-items: center;
flex-direction: column;
`;

const Input = styled(TextField)`
  width: 70%
  input {
    color: #000;
  }
  .MuiInput-underline:after {
    border-color: #FE4642;
  }
  .MuiFormLabel-root.Mui-focused {
    color: #FE4642 !important;
  }
`;
const FormWrapper = styled.div`
  background: white;
  width: 30%;
  height: 40%;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
`;
const LoginTitle = styled.h3`
  color: black;
  font-size: 28px;
  margin: 10px 0;
`;
const LoginButton = styled(SpinnerLoginButton)`
  margin-top: 40px !important;
  width: 100%;
  background-color: #FE4642 !important;
`;


const mapStateToProps = (state, dispatch) => ({ dispatch, alert: state.alert });

export default injectIntl(connect(mapStateToProps)(Login));
